<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
            </v-row>
            <!--<v-container>
                <v-row>
                    <v-col md="6" cols="12" class="executivedate">
                         Filter by Year 
                        <v-menu v-model="yearMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                              :label="$t('Year')"
                                              readonly
                                              v-bind="attrs" @input="selectYear(null)"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :max="maxDate"
                                           type="year" @click:year="selectYear($event)"></v-date-picker>
                        </v-menu>

                    </v-col>
                    <v-col md="6" cols="12">
                         Filter by Quarter (using Calendar) 
                        <v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                  :items="quarters"
                                  :label="$t('Quarter')"></v-select>
                    </v-col>
                </v-row>
            </v-container>-->
            <v-dialog v-model="dialog" persistent max-width="700px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorOne"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorTwo"
                                                mode="hexa"></v-color-picker>
                            </v-col>

                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Vertical layout -->
            <v-row v-if="value.length>0">
                <v-col cols="12" style="margin:auto; margin-right: 130px;">
                    <template>

                        <v-row class="pa-4 mt-2">

                            <!--<v-col cols="2"></v-col>-->
                            <!-- No Section -->
                            <v-col cols="7" v-for="(item, index) in value"  :key="index" :style="`border: 1px solid ${item.name == 'yes' || item.name == 'نعم'?colorOne:colorTwo}; border-radius: 8px; padding: 8px;margin:5px`" @click="filterQuestionOption(item)">
                                <v-row>
                                    <v-col cols="2" class="text-center"><img :src="item.name == 'yes' || item.name == 'نعم'?'/yestwo.png':'/notwo.png'" style="width:50px" /><br /><span style="font-size: 21px; color: #000;">{{item.name}}</span></v-col>
                                    <v-col style="font-size: 21px; color: #000;" class="text-center"><span :style="{color: (item.name == 'yes' || item.name == 'نعم'?colorOne:colorTwo)}">{{item.value}}%</span><br /><span style="font-size: 21px;" class="text-right">{{item.name == 'yes' || item.name == 'نعم'?$t('ContractSigned'):$t('ContractNotSigned')}}</span><br /><span style="font-size: 21px;">{{item.count}}</span></v-col>
                                </v-row>

                            </v-col>
                            
                            <!--<v-col cols="2"></v-col>-->
                        </v-row>
                    </template>

                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined
        },
        data() {
            return {
                selectedChart: 'chart2', // Default to horizontal view
                colorOne: '#4bc0c0',
                colorTwo: '#ff6384',
                dialog: false,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        computed: {
        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectSignedQuestionYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectSignedQuestionQuarter', quarter)
            },
            filterQuestionOption(item) {
                this.$emit('filterQuestionOption', item, this.q, this.value)
            }
        }
    }
</script>

<style scoped>
    v-btn {
        background: linear-gradient(to right, #2fbcd3, #62c6c8);
    }
</style>
